module.exports = __webpack_public_path__ + "static/media/chat-logo.29d658a2.svg";